import { lazy, Suspense, useEffect, useState } from 'react';

import { useAuthenticator } from '@aws-amplify/ui-react';
import CookieConsent from 'react-cookie-consent';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useRecoilValue, useRecoilState } from 'recoil';

import { useTheme, useMediaQuery } from '@mui/material';
import Alert from '@mui/material/Alert';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import useScrollTrigger from '@mui/material/useScrollTrigger';

import Footer from './footer/Footer';
import Header from './header/Header';
import Loading from './loading/Loading';
import Cookies from 'js-cookie';
import { ErrorState, LoadingState } from '../AppState';

const Auth = lazy(() => import('../views/Auth'));
const Dashboard = lazy(() => import('../views/Dashboard'));

const PublicLayout = () => {
  const theme = useTheme();

  const loading = useRecoilValue(LoadingState);
  const [error, setError] = useRecoilState(ErrorState);
  const [cookiesAccepted, setCookiesAccepted] = useState(false || Cookies.get('CookieConsent'));
  // const [open, setOpen] = useState(true);

  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  const scrollTrigger = useScrollTrigger({
    target: window,
    disableHysteresis: true,
    threshold: 8,
  });

  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  const handleAccept = async () => {
    Cookies.set('cookiesAccepted', 'true', { expires: 365 });
    setCookiesAccepted(true);
  };

  const handleDecline = async () => {
    Cookies.remove('cookiesAccepted');
    setCookiesAccepted(true);

  };

  useEffect(() => {
    const cookiesAcceptedValue = Cookies.get('cookiesAccepted');
    if (cookiesAcceptedValue === 'true') {
      setCookiesAccepted(true);
    }
  }, []);
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Box>
          <Header transparent={!scrollTrigger} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
          }}
        >
          <Box
          >
            {error && <Alert severity="error">{error}</Alert>}
          </Box>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/auth" element={<Auth />} />
              <Route path="/" element={<Dashboard />} />
            </Routes>
          </Suspense>
        </Box>
        <Snackbar
          open={!cookiesAccepted}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          children={
            <Paper>
              <Stack direction="row" margin={theme.spacing(2)} spacing={theme.spacing(2)}>
                <CookieConsent
                  enableDeclineButton
                  onAccept={handleAccept}
                  onDecline={handleDecline}
                  buttonText="Accept"
                  declineButtonText="Decline"
                  disableStyles
                  ButtonComponent={Button}
                  customButtonProps={{
                    size: 'small',
                    variant: 'contained',
                  }}
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexGrow: 1,
                  }}
                  // visible={cookiesAccepted ? 'hidden' : 'visible' }
                >
                  We are using cookies to give you the best experience on our website.
                </CookieConsent>
              </Stack>
            </Paper>
          }
        />
        <Box marginTop="auto">
          <Footer />
        </Box>
      </Box>
      <Backdrop open={loading} sx={{ color: theme.palette.primary.main, zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress />
      </Backdrop>
    </>


    // <Box>
    //   <Suspense fallback={<Loading />}>
    //     <Routes>
    //       <Route path="/auth" element={<Auth />} />
    //       <Route path="/" element={<Dashboard />} />
    //     </Routes>
    //   </Suspense>
    // </Box>
  );
};

export default PublicLayout;
